import { Field, Form } from "react-final-form";
import { onSubmit, onValidate } from "./PrintDocumentEmailFormSubmit";
import "./PrintDocumentEmailForm.scss";
import BMXButton from "../../../../Components/Buttons/BMXButton/BMXButton";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import BMXAutocomplente from "../../../../Components/Inputs/BMXAutocomplete/BMXAutocomplete";
import { createFilterOptions, Icon, IconButton, Popover } from "@mui/material";
import { useEffect, useState } from "react";
import BMXTextField from "../../../../Components/Inputs/BMXTextField/BMXTextField";
import moment from "moment";



const HistoryPopover = (props) => {

  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <IconButton aria-describedby={id} variant="contained" onClick={handleClick}><Icon>history_icon</Icon></IconButton>

      <Popover
        disablePortal
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        disableScrollLock
      >
        <div className="m-3">
          <h6>{t("global:PrintDocumentEmailForm.history")}:</h6>
          <ul >
            {props?.reportSentSet?.map(el => <li>{moment(el?.createdAt).format("DD/MM/YYYY HH:mm")} - {el?.sentTo}</li>)}
          </ul>
        </div>
      </Popover>
    </div>
  );
}


const PrintDocumentEmailForm = (props) => {
  const filter = createFilterOptions();
  const printData = JSON.parse(sessionStorage.getItem("printData"));

  const { t } = useTranslation();

  const { usersToSendEmail, optimaCheckBox, printDataOptimaId } = props

  const [emailsOptions, setEmailsOptions] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setEmailsOptions(usersToSendEmail?.map((el) => ({
      email: el?.label,
      uuid: el?.uuid,
      ...el
    })));
  }, [usersToSendEmail])

  return (
    <Form
      initialValues={{}}
      onSubmit={(val) => onSubmit(val, { ...props, setIsLoading })}
      validate={(val) => onValidate(val, props)}
    >
      {(formProps) => {
        const { form, values } = formProps;
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="PrintDocumentEmailForm"
          > {Boolean(optimaCheckBox) ?
            <Row>
              <Col>
                <Field
                  component={BMXTextField}
                  fieldtype={"checkbox"}
                  label={`${t("global:PrintDocumentEmailForm.report")}`}
                  name="report"
                  data-cy="report"
                  className={`py-0 ${Boolean(printDataOptimaId) ? 'my-2' : 'my-3'}`}
                />
                {Boolean(printDataOptimaId) ?
                  <Field
                    component={BMXTextField}
                    fieldtype={"checkbox"}
                    label={`${t("global:PrintDocumentEmailForm.faVat")}`}
                    name="faVat"
                    data-cy="faVat"
                    className="py-0 my-2"
                  /> : null}
                <div>

                  <span className="d-flex pb-3 justify-content-between">{t("global:PrintDocumentEmailForm.ToEmail")}:
                    {printData?.reportSentSet?.length > 0 ? <HistoryPopover {...printData} /> : null}

                  </span>
                  <ul>{(Boolean(usersToSendEmail) && (usersToSendEmail.length > 0)) ? usersToSendEmail.map(el => <li>{el}</li>) : null}</ul>
                </div>
              </Col>
            </Row> :
            <Row>
              <Col>
                <Field
                  component={BMXAutocomplente}
                  label={`${t("global:PrintDocumentEmailForm.emails")}`}
                  name="emails"
                  data-cy="emails"
                  options={emailsOptions}
                  currentValues={values}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const { inputValue } = params;
                    if (filtered?.length <= 0){
                      form.change("email", inputValue);
                    }
                    return filtered;
                  }}
                  slotProps={{
                    popper: {
                      sx: {
                        zIndex: 99999999999999999999,
                      },
                    },
                  }}
                />
              </Col>
            </Row>
            }
            <BMXButton disabled={((!values.report && !values.faVat && Boolean(props?.optimaCheckBox)) || Boolean(isLoading))} bmxclass="Success" type="submit">{Boolean(isLoading) ? t("global:sending") : t("global:send")}</BMXButton>
          </form>
        );
      }}
    </Form>
  );
};

export default PrintDocumentEmailForm;
